module.exports = __webpack_public_path__ + "img/click.6804ee93.png";